import capitalize from 'lodash/capitalize';

/**
 * Translate card brand shorthand to the full name
 */
export const cardBrand = (cardBrand: string) => {
  switch (cardBrand) {
    case 'amex':
      return 'American Express';
    case 'mastercard':
      return 'Master Card';
    default:
      return capitalize(cardBrand);
  }
};

/**
 * Format a number/string as currency
 */
export const currency = (currency: number | string) =>
  new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
  }).format(currency as number);

/**
 * Format a number/string as a percentage
 */
export const percentage = (value: number | string, minimumFractionDigits = 0, maximumFractionDigits = 2) =>
  new Intl.NumberFormat('en-CA', {
    style: 'percent',
    maximumFractionDigits,
    minimumFractionDigits,
  }).format((value as number) / 100);

/**
 * Format phone number
 */
export const phone = (phone: string, phoneExt?: string) => {
  const formattedPhoneExt = phoneExt ? ` ext. ${phoneExt}` : '';
  return `${phone}${formattedPhoneExt}`;
};

/**
 * Format phone number for use in anchor href
 *
 * The `,` adds a 2 second pause and any numbers that follow will be dialed.
 * For more info, see https://www.lifewire.com/automatically-dialing-extensions-on-android-577619
 */
export const phoneHref = (phone: string, phoneExt?: string) => {
  const formattedPhoneExt = phoneExt ? `,${phoneExt}` : '';
  return `tel:${phone}${formattedPhoneExt}`;
};

/**
 * Normalize a phone number input by adding hyphens, restricting non-digit characters, and
 * limiting the length to 12 characters.
 *
 * @param phone - The input string triggered by the user.
 * @return The normalized phone number as a string.
 */
export const phoneNormalize = (phone: string) =>
  phone
    .replace(/[^-\d]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    .substring(0, 12) || '';
